import VDialog from './VDialog.vue';

export { VDialog };
export default VDialog;
